module.exports = __webpack_public_path__ + "static/media/420df4e4.jpg";